import styled, { css } from 'styled-components'
import { AutoComplete, Input } from 'antd'
import { themeColor, themeFontFamily, IconComponent } from 'LibNeo'
import { SelectWrapper } from 'LibNeo/components/Basic/Select/Select/styled'

export const SelectWithOtherWrapper = styled(SelectWrapper)<{
	isEmpty?: boolean
}>`
	.ant-select-dropdown {
		& > div::before {
			content: '${({ isEmpty }) =>
				isEmpty ? 'Совпадений нет, укажите своё значение' : 'Можно выбрать'}';
			display: block;
			color: ${themeColor('gray', 6)};
			font-family: ${themeFontFamily('SBSansInterface')};
			font-size: 12px;
			line-height: 20px;
			padding: 4px 16px;
			background-color: ${({ isEmpty }) =>
				isEmpty ? themeColor('gold', 1) : themeColor('gray', 1)};
			border-top-left-radius: 6px;
			border-top-right-radius: 6px;
		}

		&:empty {
			border: none;
		}
	}
	.ant-select-dropdown-menu {
		li:first-child {
			margin-top: 0;
		}
	}
`

export const InputStyled = styled(Input)<{
	$hasError?: boolean
	disabled?: boolean
}>`
	&,
	&.ant-input,
	&.ant-select-auto-complete.ant-select,
	&.ant-select-search__field {
		position: relative;
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		height: 40px;
		padding: 0;
		border: 1px solid
			${({ $hasError }) => ($hasError ? themeColor('pink', 5) : themeColor('gray', 3))};
		background-color: ${({ disabled }) => (disabled ? themeColor('gray', 1) : themeColor('white'))};
		border-radius: 6px;
		outline: none;
		box-shadow: none;
		box-sizing: border-box;
		overflow: hidden;

		${({ $hasError, disabled }) => {
			if (!disabled && !$hasError)
				return css`
					&:hover {
						border-color: ${themeColor('gray', 5)};
					}
				`
			if ($hasError)
				return css`
					&,
					&.ant-select-search__field,
					&.ant-input {
						&,
						&:hover,
						&:focus {
							border-color: ${themeColor('pink', 5)};
						}
					}
				`
		}}
		svg {
			fill: ${({ disabled }) => (disabled ? themeColor('gray', 4) : themeColor('gray', 5))};
		}
	}
	& > .ant-input {
		border: none;
	}
	&.ant-input,
	& > .ant-input {
		font-family: ${themeFontFamily('SBSansInterface')};
		font-weight: normal;
		font-size: 14px;
		line-height: 20px;
		color: ${({ disabled }) => (disabled ? themeColor('gray', 6) : themeColor('gray', 8))};
		padding: 9px 15px;
		&::placeholder {
			color: ${themeColor('gray', 4)};
		}
	}
	&.ant-input-affix-wrapper .ant-input {
		&,
		&:focus {
			outline: none;
			box-shadow: none;
		}
	}

	.ant-input-suffix {
		position: relative;
		height: 100%;
		padding-right: 11px;
		right: auto;
		align-items: center;
	}
`
export const Icon = styled(IconComponent)``

export const AutoCompleteStyled = styled(AutoComplete)<{
	$hasError?: boolean
	$isEmpty?: boolean
	highligth?: boolean
}>`
	display: block;
	& .anticon {
		visibility: hidden;
	}
	.ant-select-search__field {
		${({ highligth }) =>
			highligth &&
			css`
				border: 1px solid ${themeColor('sun')};
			`}
		${({ $hasError }) =>
			$hasError &&
			css`
				border: 1px solid ${themeColor('pink', 5)};
			`}
	}
	.ant-select-selection {
		border-radius: 6px;
		&__clear {
			opacity: 1;
			.ant-select-clear-icon {
				svg {
					visibility: hidden;
				}
				&:before {
					content: '';
					position: absolute;
					display: block;
					visibility: visible;
					margin-top: -4px;
					margin-left: -8px;
					height: 20px;
					width: 20px;
					background-color: ${themeColor('gray', 4)};
					mask-image: url('/svg/icon-close.svg');
					-webkit-mask-image: url('/svg/icon-close.svg');
				}
				&:hover {
					&:before {
						background-color: ${themeColor('gray', 8)};
					}
				}
			}
		}
	}
	&.ant-select-auto-complete.ant-select .ant-input {
		height: 40px;
		padding: 9px 15px;
		font-size: 14px;
	}
	.ant-select-selection {
		${Icon} {
			visibility: ${({ $isEmpty }) => ($isEmpty ? 'hidden' : 'visible')};
		}
	}
	&.ant-select-open {
		.ant-select-selection {
			box-shadow: none;
			${Icon} {
				transform: rotate(180deg);
			}
		}
	}
	&.ant-select-focused {
		.ant-select-selection {
			box-shadow: none;
			${InputStyled} {
				&,
				&:hover {
					border-color: ${({ $hasError }) =>
						$hasError ? themeColor('pink', 5) : themeColor('emerald', 6)};
				}
			}
		}
	}
	&.ant-select-auto-complete .ant-select-selection--single {
		height: 40px;
	}
	&.ant-select-combobox .ant-select-selection:hover .ant-select-selection__rendered {
		margin-right: 0;
	}

	&.ant-select-disabled {
		opacity: 1;
		.ant-input[disabled] {
			background-color: transparent;
			color: ${themeColor('gray', 6)};
		}
	}

	&.ant-select-dropdown-menu-item {
		white-space: initial;
		text-overflow: initial;
	}
`
